export const imports = {
  'src/docs/Card.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-card" */ 'src/docs/Card.mdx'
    ),
  'src/docs/Flex.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-flex" */ 'src/docs/Flex.mdx'
    ),
  'src/docs/Floating.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-floating" */ 'src/docs/Floating.mdx'
    ),
  'src/docs/Input.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-input" */ 'src/docs/Input.mdx'
    ),
  'src/docs/Label.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-label" */ 'src/docs/Label.mdx'
    ),
  'src/docs/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-docs-index" */ 'src/docs/index.mdx'
    ),
}
